import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import resources from "./locales";

export const LANGUAGE_STORAGE_KEY = "LANGUAGE";
export const DEFAULT_LANGUAGE = "zh-TW";
export const SUPPORTED_LANGUAGES = ["zh-TW", "en"];

// The old I18N_LANGUAGE key was always set to "en" by the Velzon template,
// so it is ignored and every user starts on the default language.
const getInitialLanguage = () => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (SUPPORTED_LANGUAGES.includes(stored)) return stored;
  } catch (e) {
    // localStorage may be unavailable (private mode)
  }
  return DEFAULT_LANGUAGE;
};

const setDocumentLanguage = (lng) => {
  document.documentElement.setAttribute("lang", lng);
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

setDocumentLanguage(i18n.language);

i18n.on("languageChanged", (lng) => {
  setDocumentLanguage(lng);
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch (e) {
    // ignore
  }
});

export default i18n;
